import React, { createRef } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Alert,
} from 'js/ui/legacy';
import type { WithTranslation } from 'react-i18next';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import barcodeActions, { selectors } from 'js/redux/reducers/BarcodeAction';
import type { RootState } from 'js/redux/reducers';
import type { AppDispatch } from 'js/redux/Store';

type BarcodeRejectedModalProps = WithTranslation &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class BarcodeRejectedModal extends React.Component<BarcodeRejectedModalProps> {
  okButtonRef: React.RefObject<HTMLButtonElement>;

  constructor(props: BarcodeRejectedModalProps) {
    super(props);
    this.okButtonRef = createRef(); // Create a ref
  }

  componentDidUpdate(prevProps: BarcodeRejectedModalProps) {
    // If the modal just opened, set focus on the OK button
    if (!prevProps.rejected && this.props.rejected) {
      setTimeout(() => {
        this.okButtonRef.current?.focus();
      }, 100);
    }
  }
  render() {
    const { t, rejected } = this.props;
    return (
      <Modal isOpen={!!rejected} toggle={this.props.clear} centered>
        <ModalHeader toggle={this.props.clear}>
          {rejected?.title ??
            t('lbl.barcodeActionError', 'Barcode action error')}
        </ModalHeader>
        <ModalBody>
          <Alert color="warning">{rejected?.msg}</Alert>
        </ModalBody>
        <ModalFooter>
          <Row style={{ width: '100%' }}>
            <Col xs={9} />
            <Col>
              <Button
                innerRef={this.okButtonRef}
                data-testid="barcode_rejected_btn_ok"
                color="primary"
                onClick={this.props.clear}
              >
                {t('fn.ok', 'OK')}
              </Button>{' '}
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    );
  }
}

function mapStateToProps(store: RootState) {
  return {
    rejected: selectors.barcodeaction_error(store),
  };
}

function mapDispatchToProps(dispatch: AppDispatch) {
  return bindActionCreators(
    {
      clear: barcodeActions.clearBarcodeState,
    },
    dispatch
  );
}

export default withTranslation('translations')(
  connect(mapStateToProps, mapDispatchToProps)(BarcodeRejectedModal)
);
